import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { config } from '../config/config';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {

  private apiUrl = `${config.examApiBaseUrl}/call`;
  private userPermissionsUrl = `${config.examApiBaseUrl}/users/permissions`;
  private allUserPermissionsUrl = `${config.examApiBaseUrl}/users/permissions/all`;
  userId: number = 0;
  private branchesUrl = `${config.examApiBaseUrl}/exam/branches`;

  constructor(private http: HttpClient) { }

  getUserPermissions(userEmail:string): Observable<any> {
    return this.http.get<any>(`${this.userPermissionsUrl}?email=${encodeURIComponent(userEmail)}`);
  }

  getAllUserPermissions(): Observable<any> {
    return this.http.get<any>(this.allUserPermissionsUrl);
  }

  setUserId(id: number): void {
    this.userId = id;
  }

  getUserId(): number {
    return this.userId;
  }

  updateUserPermissions(userID: number, permissions: string, branchId: number, branchName: string): Observable<any> {
    const body = {
      permissions,
      updatedBy: this.userId,
      branchId,
      branchName,
    };
    return this.http.put<any>(`${config.examApiBaseUrl}/users/${userID}/permissions`, body, { headers: { 'Content-Type': 'application/json' }});
  }
  
  addNewUser(username: string, email: string, branchId: number, branchName: string): Observable<any> {
      const body = {
      procedureName: 'sp_InsertUser',
      params: {
        Username: username,
        Email: email,
        CreatedBy: this.userId,
        branchId: branchId,
        branchName: branchName
      }
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }

  getAllBranches(): Observable<any> {
    return this.http.get<any>(this.branchesUrl);
  }
}
